<template>
  <home-dashboard />
</template>

<script>
import HomeDashboard from '../Home.vue'

export default {
  name: 'Dashboard',
  components: {
    HomeDashboard
  }
}
</script>
